/**
 * Builds merged QueryBuilder field configs for delivery-step tabs: curated
 * delivery-step status fields plus condition-list (CMM) columns for the first
 * dropdown in each condition row.
 */
import { QueryBuilderConfig } from "../../../../../data-model/queryBuilder";
import { buildCallingConditionConfigFromCmmColumns } from "../../callingConfiguration/callingRuleUtils";
import { CmmInputUniqueValuesDoc } from "../../validationFunnel/pages/conditionList/cmmInputUniqueValuesTypes";
import { DELIVERY_STEP_FIELD_CONFIG } from "./deliveryStepFields";

/**
 * Merges the curated delivery-step fields with condition-list columns from the
 * CMM input unique values document. Delivery-step definitions are listed first and
 * win on name collisions; CMM-only columns are appended.
 *
 * @param cmmDoc - CMM input unique values document (condition list source)
 * @returns QueryBuilder config for preconditions / run conditions
 */
export function buildDeliveryStepConditionConfig(
  cmmDoc: CmmInputUniqueValuesDoc | null,
): QueryBuilderConfig {
  const conditionListConfig = buildCallingConditionConfigFromCmmColumns(cmmDoc);
  const deliveryFieldNames = new Set(
    DELIVERY_STEP_FIELD_CONFIG.fields.map((field) => field.value),
  );
  const conditionListOnlyFields = conditionListConfig.fields.filter(
    (field) => !deliveryFieldNames.has(field.value),
  );

  return {
    fields: [
      ...DELIVERY_STEP_FIELD_CONFIG.fields,
      ...conditionListOnlyFields,
    ],
  };
}
